<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div >
            <div class="m-portlet m-b-10" :style="{'height':(160)+'px'}">
                <div class="m-portlet__body">
                    <el-form  label-width="150px">
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="班主任">
                                    <el-select v-model="form.headTeacher_id" clearable placeholder="请选择班主任"
                                               filterable remote
                                               :remote-method="handleSearchHeadTeacher"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in headTeachers"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="学校">
                                    <el-select v-model="form.school_id" clearable placeholder="请选择学校" filterable
                                               remote
                                               :remote-method="handleSearchSchool" @change="handleChange()">
                                        <el-option
                                                v-for="item in schools"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="年级">
                                    <el-select v-model="form.grade_id" clearable placeholder="请选择年级"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in grades"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="学生名字">
                                    <el-select v-model="form.student_id" clearable placeholder="请选择学生名字" filterable
                                               remote
                                               :remote-method="handleSearchStudent" @change="handleChange()">
                                        <el-option
                                                v-for="item in haveStudents"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="待续班学期">
                                    <el-select v-model="form.semester_id" placeholder="请选择学期"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in semesters"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否有续班学生">
                                    <el-select v-model="form.renewalStudent" clearable placeholder="请选择是否有续班学生"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in renewalStudents"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否有班主任的学生">
                                    <el-select v-model="form.hasHeadTeacherStudent" clearable
                                               placeholder="请选择是否有班主任的学生"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in hasHeadTeacherStudents"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="学科">
                                    <el-select v-model="form.subject_id" clearable placeholder="请选择学科"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in subjects"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="m-portlet m-b-0" :style="{'height':(clientHeight-270)+'px'}">
                <div class="m-portlet__body"  v-loading="loading" :style="{'height':clientHeight-300+'px'}">
                    <el-table
                            :data="orderStudents"
                            style="width: 100%"
                            size="middle"
                            :height="clientHeight-360"
                    >
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column label="学校">
                            <template slot-scope="scope">
                                <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.school.name}}</span>
                                <span v-else>学校未添加</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="年级">
                            <template slot-scope="scope">
                                <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.grade.name}}</span>
                                <span v-else>年级未添加</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" label="电话"></el-table-column>
                        <el-table-column label="课程(now)" width="200">
                            <template slot-scope="scope">
                                <div v-for="(nowUseSubject,index) in scope.row.nowUseSubjects" :key="index"
                                     @mouseover="toggleShow(nowUseSubject.id,scope.row.id)"
                                     @mouseout="toggleShow(nowUseSubject.id,scope.row.id)"
                                     style="float: left">
                                    <el-popover
                                            placement="bottom"
                                            width="400"
                                            trigger="hover">
                                        <el-row :gutter="20">
                                            <el-col :span="12">{{oneSemester.name}}课程
                                                <p v-for="(nowClass,index) in scope.row.nowClasses" :key="index">
                                                    <span v-if="nowClass.subject_id === uselSubject">{{nowClass.name}} <b>{{nowClass.teacher}}</b> </span>
                                                </p>
                                            </el-col>
                                            <el-col :span="12">{{twoSemester.name}}课程
                                                <p v-for="(nextClass,index) in scope.row.nextClasses" :key="index">
                                                    <span v-if="nextClass.subject_id === uselSubject">{{nextClass.name}} <b>{{nextClass.teacher}}</b> </span>
                                                </p>
                                            </el-col>
                                        </el-row>
                                        <el-button slot="reference" size="mini"
                                                   style="background-color: hsla(220,4%,58%,.1);border-color: hsla(220,4%,58%,.2);color: #909399;margin: 0 2px">
                                            {{nowUseSubject.name}}
                                        </el-button>
                                    </el-popover>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="课程(next)" width="200">
                            <template slot-scope="scope">
                                <div v-for="(nextUseSubject,index) in scope.row.nextUseSubjects" :key="index"
                                     style="float: left">
                                    <el-button size="mini"
                                               style="background-color: rgba(64,158,255,.1);border-color: rgba(64,158,255,.2);color: #409eff;margin: 0 2px">
                                        {{nextUseSubject.name}}
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="续班学科" width="200">
                            <template slot-scope="scope">
                                <div v-for="(renewalSubject,index) in scope.row.renewalSubjects" :key="index"
                                     style="float: left">
                                    <el-button size="mini"
                                               style="background-color: rgba(103,194,58,.2);border-color: rgba(103,194,58,.2);color: #67c23a;margin: 0 2px">
                                        {{renewalSubject.name}}
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="未续班学科" width="200">
                            <template slot-scope="scope">
                                <div v-for="(notRenewalSubject,index) in scope.row.notRenewalSubjects" :key="index"
                                     style="float: left">
                                    <el-button size="mini"
                                               style="background-color: hsla(0,87%,69%,.2);border-color: hsla(0,87%,69%,.2);color: #f56c6c;margin: 0 2px">
                                        {{notRenewalSubject.name}}
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="班主任">
                            <template slot-scope="scope">
                                <span v-for="(headTeacher,index) in scope.row.headTeachers" :key="index"> {{headTeacher.name}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini"
                                           @click="handleStudentInformation(scope.row.id,scope.row.name)">查看详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RenewalList",
        data() {
            return {
                isShow: false,
                path: "/subjectRenewal/list",

                form: {
                    subject_id: '',
                    student_id: '',
                    semester_id: '',
                    headTeacher_id: '',
                    school_id: '',
                    grade_id: '',
                    hasHeadTeacherStudent: '',
                    renewalStudent: '',
                },

                schools: [],
                nowSemester: [],
                haveStudents: [],
                subjects: [],
                students: [],
                semesters: [],
                headTeachers: [],
                grades: [],
                hasHeadTeacherStudents: [{
                    value: '1',
                    label: '有班主任的学生'
                }, {
                    value: '0',
                    label: '没有班主任的学生'
                }],
                renewalStudents: [{
                    value: '1',
                    label: '完全续班学生'
                }, {
                    value: '2',
                    label: '部分续班学生'
                }, {
                    value: '0',
                    label: '完全未续班学生'
                }],


                uselSubject: '',
                studentClasses: '',
                arr3: [],
                twoSemester: {},
                oneSemester: {},

                loading: true,
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            }
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.form.semester_id = this.$store.state.config.nowSemester.id;
            this.handleCreate();
            this.handleIndexRenewalList();
            this.handleShow();
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            orderStudents: function () {
                return this._.values(this.students);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            toggleShow: function (uselSubject, item) {
                this.isShow = !this.isShow;
                this.uselSubject = uselSubject;
                this.studentClasses = item;

            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'schoolKeyName',
                    'schoolKeyName': query,
                });
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'headTeacherKeyName',
                    'headTeacherKeyName': query,

                });
            },
            handleSearchStudent(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'studentKeyName',
                    'studentKeyName': query,

                });
            },
            handleChange() {
                this.loading = true;
                this.handleIndexRenewalList();
            },
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path, 'init', {});
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.semesters = data.semesters;
                        this.grades = data.grades;
                        this.subjects = data.subjects;
                        this.schools = data.schools;
                        this.headTeachers = data.headTeachers;
                        this.haveStudents = data.haveStudents;
                        break;
                    case 'searchSchool':
                        this.schools = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                    case 'searchStudent':
                        this.haveStudents = data.searchData;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.oneSemester = data.oneSemester;
                        this.twoSemester = data.twoSemester;
                        this.students = data.students;
                        this.loading = false;
                        break;
                    case 'list_error':
                        this.total = 0;
                        this.oneSemester = {};
                        this.twoSemester = {};
                        this.students = [];
                        this.loading = false;
                        break;
                }
            },
            handleIndexRenewalList(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'form': this.form,
                    'nowSemester_id': this.$store.state.config.nowSemester.id,
                });
            },
            handleStudentInformation(student_id, title) {
                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/student/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + student_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexRenewalList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexRenewalList(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

</style>
